export const TAG_COLOR_HEX_TO_NAME_MAP = new Map([
  ['B71F23', 'Dark Red'],
  ['ED4649', 'Medium Red'],
  ['FBA6A7', 'Light Red'],
  ['EA580C', 'Dark Orange'],
  ['FB923C', 'Medium Orange'],
  ['FED7AA', 'Light Orange'],
  ['BF9D06', 'Dark Yellow'],
  ['E7C013', 'Medium Yellow'],
  ['F8E9A7', 'Light Yellow'],
  ['67A221', 'Dark Lime'],
  ['A3E635', 'Medium Lime'],
  ['DAF8A2', 'Light Lime'],
  ['306650', 'Dark Green'],
  ['59B18D', 'Medium Green'],
  ['A8E7CD', 'Light Green'],
  ['0D9488', 'Dark Teal'],
  ['2DD4BF', 'Medium Teal'],
  ['99F6E4', 'Light Teal'],
  ['0284C7', 'Dark Sky'],
  ['38BDF8', 'Medium Sky'],
  ['BAE6FD', 'Light Sky'],
  ['1D4ED8', 'Dark Blue'],
  ['3B82F6', 'Medium Blue'],
  ['93C5FD', 'Light Blue'],
  ['9333EA', 'Dark Purple'],
  ['C084FC', 'Medium Purple'],
  ['E9D5FF', 'Light Purple'],
  ['DB2777', 'Dark Pink'],
  ['F472B6', 'Medium Pink'],
  ['FBCFE8', 'Light Pink'],
  ['464646', 'Dark Gray'],
  ['7A7972', 'Medium Gray'],
  ['CCCCC4', 'Light Gray'],
]);
